import { render } from "./hand-13.vue?vue&type=template&id=70a1a66c&scoped=true"
import script from "./hand-13.vue?vue&type=script&lang=js"
export * from "./hand-13.vue?vue&type=script&lang=js"

import "./hand-13.vue?vue&type=style&index=0&id=70a1a66c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1a66c"]])

export default __exports__